import { api } from './client'
import { getCsrfToken } from './utils'

let isRedirecting = false

api.interceptors.request.use((config) => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method ?? '')) {
    const csrf = getCsrfToken()
    if (csrf) config.headers['X-XSRF-TOKEN'] = csrf
  }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true
      localStorage.removeItem('user')
      localStorage.removeItem('workspace')
      window.location.href = '/login'
      setTimeout(() => { isRedirecting = false }, 3000)
    }

    if (error.response?.status === 403) {
      console.warn('[CharityConnect] Access forbidden:', error.response.data?.message)
    }

    return Promise.reject(error)
  },
)

export default api
